import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/logo.png';
var _hoisted_1 = {
  "class": "container"
};
var _hoisted_2 = {
  "class": "rows flex justify-between pt-6 md:pt-10"
};
var _hoisted_3 = {
  "class": "items"
};
var _hoisted_4 = {
  "class": "items"
};
var _hoisted_5 = {
  "class": "flex items-center pt-4 md:pt-10 pb-4 justify-center"
};
export function render(_ctx, _cache) {
  var _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("footer", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[10] || (_cache[10] = _createElementVNode("div", {
    "class": "items max-w-[360px]"
  }, [_createElementVNode("p", null, [_createElementVNode("img", {
    "class": "logo",
    src: _imports_0
  })]), _createElementVNode("p", {
    "class": "text-xs"
  }, " 专业从事APQP项目质量管理、8D、ISO文档管理、全价值链质量管理软件开发、方案解决和技术咨询服务的专业机构。 ")], -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t("title_products")), 1), _createElementVNode("p", null, [_createVNode(_component_router_link, {
    to: "/bolearnai"
  }, {
    "default": _withCtx(function () {
      return _cache[0] || (_cache[0] = [_createTextVNode("bolearn AI平台")]);
    }),
    _: 1
  })]), _createElementVNode("p", null, [_createVNode(_component_router_link, {
    to: "/bolearnai-train"
  }, {
    "default": _withCtx(function () {
      return _cache[1] || (_cache[1] = [_createTextVNode("bolearn AI陪练")]);
    }),
    _: 1
  })]), _createElementVNode("p", null, [_createVNode(_component_router_link, {
    to: "/products"
  }, {
    "default": _withCtx(function () {
      return _cache[2] || (_cache[2] = [_createTextVNode("全价值链质量管理软件")]);
    }),
    _: 1
  })]), _createElementVNode("p", null, [_createVNode(_component_router_link, {
    to: "/products"
  }, {
    "default": _withCtx(function () {
      return _cache[3] || (_cache[3] = [_createTextVNode("APQP项目管理软件")]);
    }),
    _: 1
  })]), _createElementVNode("p", null, [_createVNode(_component_router_link, {
    to: "/products"
  }, {
    "default": _withCtx(function () {
      return _cache[4] || (_cache[4] = [_createTextVNode("8D问题分析与解决管理软件")]);
    }),
    _: 1
  })]), _createElementVNode("p", null, [_createVNode(_component_router_link, {
    to: "/products"
  }, {
    "default": _withCtx(function () {
      return _cache[5] || (_cache[5] = [_createTextVNode("ISO文档系统管理软件")]);
    }),
    _: 1
  })])]), _createElementVNode("div", _hoisted_4, [_cache[6] || (_cache[6] = _createElementVNode("h3", null, "联系我们", -1)), _cache[7] || (_cache[7] = _createElementVNode("p", null, "地址：苏州市人民路3188号万达广场B幢2109B室", -1)), _cache[8] || (_cache[8] = _createElementVNode("p", null, "全国服务热线：0512-68666692", -1)), _createElementVNode("p", null, _toDisplayString(_ctx.$t("span_mobile")) + "：+86 13862170076（刘先生）", 1), _cache[9] || (_cache[9] = _createElementVNode("p", null, "浙江区域：+86 13003679913（赵先生）", -1))])]), _createElementVNode("p", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("companyName")), 1), _cache[11] || (_cache[11] = _createElementVNode("span", {
    "class": "px-4"
  }, "Copyright © 2025 - HANWEILINK.COM All Rights Reserved", -1)), _cache[12] || (_cache[12] = _createElementVNode("span", null, [_createElementVNode("a", {
    href: "http://beian.miit.gov.cn",
    target: "_blank",
    rel: "nofollow"
  }, "苏ICP备2021042626号")], -1))])])]);
}